import {currentPlatform} from "./platform";

export const outline = () => currentPlatform.isWeb() ? {outline: 'none'} : {}
